import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";

class UpdateMiscellanySalePriceStore {

    public salePriceId: string;
    public miscellanyCategoryId: string;
    public value: number;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    public changeError?: string;

    constructor(commonStore: CommonStore, salePriceId: string, miscellanyCategoryId: string, value: number) {
        this.salePriceId = salePriceId;
        this.miscellanyCategoryId = miscellanyCategoryId;
        this.value = value;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async save() {
        const response = await SalePriceService.updateMiscellanySalePrice(this.salePriceId, this.miscellanyCategoryId, this.value);
        this.commonStore.processErrors(response);
        return response.success;
    }

}

export default UpdateMiscellanySalePriceStore;